export interface NavigationScope {
  companyId?: string;
  siteId?: string;
  pointId?: string;
}

const SCOPE_KEYS = ["company", "site", "point"] as const;

export function scopedPath(path: string, scope: NavigationScope): string {
  const url = new URL(path, "https://ems.local");
  url.searchParams.set("context", "1");
  url.searchParams.delete("scopeError");
  for (const key of SCOPE_KEYS) url.searchParams.delete(key);
  if (scope.companyId) url.searchParams.set("company", scope.companyId);
  if (scope.siteId) url.searchParams.set("site", scope.siteId);
  if (scope.pointId) url.searchParams.set("point", scope.pointId);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function safeInternalReturnTo(value: string | null): string | null {
  if (!value || value.length > 2_000 || !value.startsWith("/app/")) return null;
  try {
    const url = new URL(value, "https://ems.local");
    if (
      url.origin !== "https://ems.local" ||
      !url.pathname.startsWith("/app/") ||
      value.includes("\\")
    )
      return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function correctionPath(
  destination: string,
  returnTo: string,
  focus?: string,
): string {
  const url = new URL(destination, "https://ems.local");
  const safeReturn = safeInternalReturnTo(returnTo);
  if (safeReturn) url.searchParams.set("returnTo", safeReturn);
  if (focus) url.searchParams.set("focus", focus);
  return `${url.pathname}${url.search}${url.hash}`;
}
